import template from './adpMainBreadcrumb.html';
import controller from './adpMainBreadcrumb.controller';
import './adpMainBreadcrumb.less';

let adpMainBreadcrumbComponent = {
  restrict: 'E',
  bindings: {
    breadcrumbsList: '<'
  },
  template,
  controller
};

export default adpMainBreadcrumbComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpMainBreadcrumb/adpMainBreadcrumb.component.js